import React from 'react';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import SVG from '../SVG';
import { Colours } from '../../tokens';
const useStyles = createUseStyles({
    root: {
        color: Colours.primary,
    },
});
const BackArrowIcon = ({ className }) => {
    const styles = useStyles();
    return (React.createElement(SVG, { width: "16", height: "16", viewBox: "0 0 16 16", className: classNames(styles.root, className) },
        React.createElement("g", { transform: "translate(-108 -252)" },
            React.createElement("g", { transform: "translate(108 252)" },
                React.createElement("path", { d: "M4.544,5.043A.494.494,0,0,1,4.19,4.9L.145.851A.5.5,0,0,1,.851.145L4.544,3.837,8.236.145a.5.5,0,0,1,.706.706L4.9,4.9A.494.494,0,0,1,4.544,5.043Z", transform: "translate(3.454 9.119)", fill: "currentColour" }),
                React.createElement("path", { d: "M.5,12.216a.5.5,0,0,1-.5-.5V.5A.5.5,0,0,1,.5,0,.5.5,0,0,1,1,.5V11.716A.5.5,0,0,1,.5,12.216Z", transform: "translate(7.498 1.833)", fill: "currentColour" }),
                React.createElement("path", { d: "M0,0H16V16H0Z", fill: "none", opacity: "0" })))));
};
export default BackArrowIcon;
//# sourceMappingURL=ArrowDownIcon.js.map